<template>
    <AppLayout>
        <RegisterForm />
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import RegisterForm from '@/components/pages/Auth/RegisterForm.vue';
</script>
